import { render, staticRenderFns } from "./Regional_Partner.vue?vue&type=template&id=fe853b80&scoped=true"
import script from "./Regional_Partner.vue?vue&type=script&lang=js"
export * from "./Regional_Partner.vue?vue&type=script&lang=js"
import style0 from "./Regional_Partner.vue?vue&type=style&index=0&id=fe853b80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe853b80",
  null
  
)

export default component.exports